<template>
  <el-dialog
    class="rc-dialog"
    title="音频集共享管理"
    :visible.sync="dialogVisible"
    width="50%"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="close"
  >
    <el-form inline size="small">
      <el-form-item>
        <butn
          v-permission="'audioSet:shareAudioSet'"
          title="共享"
          :disabled="!shareEnable"
          @click="shareVideos"
        ></butn>
        <butn
          v-permission="'audioSet:cancelShareAudioSet'"
          title="取消共享"
          :disabled="!cancelEnable"
          @click="cancelShare"
        ></butn>
        <butn
          v-permission="'audioSet:recovery'"
          title="恢复"
          :disabled="!recoveryEnable"
          @click="recoveryShare"
        ></butn>
        <el-checkbox
          v-permission="'audioSet:share:online'"
          class="m-l-14"
          v-model="needOnline"
          key="needOnline"
          :true-label="1"
          :false-label="0"
          >共享或恢复后直接上线
        </el-checkbox>
      </el-form-item>
      
      <!-- <el-form-item>
        <el-input v-model="deptName" placeholder="学院名称"></el-input>
        <butn
          btntype="primary"
          class="left"
          title="查询"
          @click="getData"
        ></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
      </el-form-item> -->
    </el-form>
    <Table @selection-change="selectChange" :data="list" />
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Table from "./table.js";
import {
  audioSetSharePage,
  shareAudioSet,
  cancelShareAudioSet,
  recoveryAudioSet
} from "@/api/audioSet";
import Bus from "../Bus.js";
import { Confirm } from "@/components/Confirm";
import { Message } from "element-ui";
export default {
  components: { butn, Table },
  data() {
    return {
      dialogVisible: false,
      list: [],
      deptName: "",
      api: audioSetSharePage,
      checkArray: [],
      audioSetId: "",
      shareEnable: false,
      cancelEnable: false,
      syncEnable: false,
      recoveryEnable: false,
      needOnline: 0,
    };
  },
  created() {
    Bus.$on("shareManage", id => {
      this.dialogVisible = true;
      this.audioSetId = id;
      this.getData();
    });
    // Bus.$on("reloadShare", this.getData);
  },
  beforeDestroy() {
    Bus.$off("shareManage");
  },
  computed: {
    depIds() {
      return this.checkArray.map(ele => {
        return ele.deptId;
      });
    },
    sharedToBizIds() {
      return this.checkArray.map(ele => {
        return ele.sharedToBizId;
      });
    }
  },
  methods: {
    resetData() {
      this.deptName = "";
      this.getData();
    },
    selectChange(selections) {
      this.checkArray = selections;
      if (this.checkArray.length === 0) {
        this.shareEnable = false;
        this.cancelEnable = false;
        this.syncEnable = false;
        this.recoveryEnable = false;
      } else {
        let shareEnable = true;
        let cancelEnable = true;
        let syncEnable = true;
        let recoveryEnable = true;
        for (const ele of this.checkArray) {
          if (ele.sharedStatus === 0) {
            // 已共享状态不能勾选共享
            shareEnable = false;

            // 已共享最新空或已最新都不能勾选同步
            if (ele.isNewest === null || ele.isNewest === "1") {
              syncEnable = false;
            }

            if (ele.isDelete === "1") {
              // 已共享删除状态不能取消共享跟同步
              cancelEnable = false;
              syncEnable = false;
            } else if (ele.isDelete === "0") {
              // 已共享未删除状态恢复
              recoveryEnable = false;
            }
          } else {
            // 不是已同步状态都不能勾选取消共享、同步、恢复
            cancelEnable = false;
            syncEnable = false;
            recoveryEnable = false;
          }
        }
        this.shareEnable = shareEnable;
        this.cancelEnable = cancelEnable;
        this.syncEnable = syncEnable;
        this.recoveryEnable = recoveryEnable;
      }
    },
    getData() {
      let params = { uuid: this.audioSetId };
      if (this.deptName) {
        params["deptName"] = this.deptName;
      }
      audioSetSharePage(params).then(res => {
        if (!res || res.code != 0) return;
        this.list = res.data;
      });
    },
    shareVideos() {
      shareAudioSet({
        uuids: [this.audioSetId],
        deptIds: this.depIds,
        needOnline: this.needOnline
      }).then(res => {
        if (!res || res.code != 0) return;
        this.$message({
          message: "共享成功",
          type: "success"
        });
        this.getData();
      });
    },
    cancelShare() {
      cancelShareAudioSet({
        uuids: [this.audioSetId],
        deptIds: this.depIds,
        needOnline: this.needOnline
      }).then(res => {
        if (!res || res.code != 0) return;
        this.$message({
          message: "取消共享成功",
          type: "success"
        });
        this.getData();
      });
    },

    async recoveryShare() {
      const text = "确定恢复共享该音频集吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        recoveryAudioSet({ 
          uuids: this.sharedToBizIds,
          needOnline: this.needOnline
        }).then(res => {
          if (!res || res.code != 0) return;
          Message({
            message: "恢复成功",
            type: "success"
          });
          this.getData();
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    close() {
      this.shareEnable = false;
      this.cancelEnable = false;
      this.syncEnable = false;
      this.recoveryEnable = false;
      Bus.$emit("reload");
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    max-height: 300px;
  }
  .left {
    margin-left: 10px;
  }
  /deep/ .el-input {
    width: 50%;
  }
}
</style>
